
import { DashboardSettings } from "@/models/user-configs/dashboard-settings";
import AppCreateDashboardItem from "./CreateDashboardItem.vue";
import Vue from "vue";
import { DashboardTab } from "@/utils/dashboard/dashboard-tab";
import AppEditTab from "./EditTab.vue";
import { AuthService, DossierService, UserConfigService } from "@/services";
import { Permissions } from "@/models/user-configs/permissions";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import AppSaleTypeMultiSelect from "@/components/sales/SaleTypeMultiSelect.vue";
import AppDashboardTabShareSettings from "./DashboardTabShareSettings.vue";
import { UserInfo } from "@/models/dossier/user-info";

export default Vue.extend({
	data(){
		return {
			createItemModal: false,
			toEditTab: null as DashboardTab | null,
			isNewTab: false,
			toShareTab: null as DashboardTab | null,
			allUsers: [] as UserInfo[]
		};
	},
	props: {
		settings: {
			type: Object as ()=>DashboardSettings,
			required: true
		},
		tabs: {
			type: Array as ()=>DashboardTab[],
			required: true
		},
		items: {
			type: Array as ()=> DashboardItem[],
		},
		canEditCurrentTab: Boolean
	},
	computed: {
		hasPermissions():boolean {
			return UserConfigService.hasCurrentUserPermission((p:Permissions)=>p.CanSeeDashboard);
		},

	},
	methods: {
		canShareTab(tab:DashboardTab):boolean {
			if (this.allUsers.length <= 1){
				return false;
			}
			return tab.UserID == AuthService.wfUser.ID;
		},
		addCustomItem(){
			this.createItemModal = true;
		},
		editTab(tab:DashboardTab){
			this.toEditTab = tab;
			this.isNewTab = false;
		},
		deleteTab(tab:DashboardTab) {
			if (this.tabs.length <= 1) return;
			let i = this.tabs.indexOf(tab);
			if (i == -1) return;
			this.tabs.splice(i, 1);
			this.$emit("tab-deleted");
		},
		createTab(){
			this.toEditTab = new DashboardTab();
			this.toEditTab.UserID = AuthService.wfUser.ID;
			this.isNewTab = true;
		},
		saveTab(val:DashboardTab){
			let i = this.tabs.indexOf(val);
			if (i == -1) {
				this.tabs.push(val);
			};
		},
		onNewOrder(){
			this.$emit("sort");
		},
		shareTab(tab:DashboardTab){
			this.toShareTab = tab;
		}
	},
	async mounted(){
		this.allUsers = await DossierService.getUsers();
	},
	components: {
		AppCreateDashboardItem,
		AppEditTab,
		AppSaleTypeMultiSelect,
		AppDashboardTabShareSettings
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}
});
